// TODO: set up react ssr
// TODO: optimize core-js/tslib/regenerator-runtime/objectFitPolyfill loading conditionally in webpack config

import 'antd/dist/reset.css';
// React 19 compatibility for antd static methods (Modal.*, message.*, notification.*)
import '@ant-design/v5-patch-for-react-19';

// Avoid importing more modules than necessary here;
// init base and lazy-load components as needed
import React from 'react';
import { createRoot } from 'react-dom/client';
// polyfill
import 'setimmediate';

import AppContainer from './context/AppContainer/AppContainer';
import AppProvider from './context/AppProvider';
import ReduxProvider from './context/ReduxProvider';
import store from './data/store';
import './styles/index.scss';

const container = document.getElementById('falcon-app-root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ReduxProvider reduxStore={store.reduxStore}>
      <AppProvider>
        <AppContainer />
      </AppProvider>
    </ReduxProvider>
  </React.StrictMode>
);
